
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Autoplay } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';

import intro01 from "../assets/images/intro01.png";
import intro02 from "../assets/images/intro02.png";



const images = [intro01, intro02];



const IpadView = () => {
    const navigate = useNavigate();

    // Funzione che viene attivata al tocco dell'utente
    const handleTouch = () => {
        navigate('/ipad/register');
    };




    return (
        <div className="" onClick={handleTouch}>


            <Swiper
                modules={[Autoplay]}
                spaceBetween={0}
                slidesPerView={1}
                loop={true}  // Assicurati di aver abilitato il loop
                autoplay={{
                    delay: 5000,  // Imposta il ritardo tra le immagini a 10 sec
                    disableOnInteraction: false,  // Mantieni l'autoplay anche dopo l'interazione
                }}

            >
                {images.map((image, index) => (
                    <SwiperSlide key={index}>
                        <img src={image} alt={`Intro Slide ${index + 1}`} className="w-full h-full object-cover"/>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default IpadView;
